import { StyleSheet, View } from 'react-native'
import Skeleton, { type ICustomViewStyle } from 'react-native-reanimated-skeleton'

import { DS } from '../../design-system'
import { getDSColorWithOpacity } from '../../design-system/Palette'

/**
 * Traced from the in-app reader at phone width (site nav, share buttons and
 * the rest hidden by ArticleScreen), so the page paints over the skeleton
 * without anything moving: uppercase category, a very large serif title that
 * usually wraps to four or five lines, byline, excerpt, category pill, then the
 * top of the hero image.
 */
const TITLE_LINE_WIDTHS = ['62%', '78%', '72%', '70%', '44%'] as const
const EXCERPT_LINE_WIDTHS = ['86%', '94%', '82%', '78%'] as const

const LAYOUT: ICustomViewStyle[] = [
  {
    key: 'article',
    width: '100%',
    paddingHorizontal: DS.spacing[16],
    paddingTop: DS.spacing[48],
    children: [
      { key: 'category', width: 180, height: 12 },
      {
        key: 'title',
        width: '100%',
        marginTop: DS.spacing[48],
        gap: DS.spacing[8],
        children: TITLE_LINE_WIDTHS.map((width, index) => ({ key: `title-${index}`, width, height: 38 }))
      },
      { key: 'byline', width: 240, height: 14, marginTop: DS.spacing[48] },
      {
        key: 'excerpt',
        width: '100%',
        marginTop: DS.spacing[48],
        gap: DS.spacing[12],
        children: EXCERPT_LINE_WIDTHS.map((width, index) => ({ key: `excerpt-${index}`, width, height: 14 }))
      },
      { key: 'tag', width: 72, height: 28, borderRadius: 14, marginTop: DS.spacing[48] },
      { key: 'hero', width: '100%', height: 240, borderRadius: DS.spacing[16], marginTop: DS.spacing[32] }
    ]
  }
]

export const ArticleSkeleton = () => (
  <View style={styles.container} accessibilityLabel="Loading article" accessibilityRole="progressbar">
    <Skeleton
      isLoading
      layout={LAYOUT}
      // The library centres its layout by default; the page is top-left aligned.
      containerStyle={styles.skeleton}
      boneColor={DS.palette['Brand/Light Grey']}
      highlightColor={getDSColorWithOpacity('Global/White', 0.5)}
    />
  </View>
)

const styles = StyleSheet.create({
  skeleton: {
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  container: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Cream']
  }
})
